import Layout from '@/layout';
export default [
  {
    path: '/activity',
    name: 'Activity',
    component: Layout,
    redirect: '/activity/star',
    meta: {
      title: '激励计划',
      icon: 'icon-activity',
    },
    children: [
      {
        path: 'star',
        name: 'star-rev',
        component: () => import('@/views/activity/star.vue'),
        meta: {
          title: '星启计划',
        },
      },
      {
        path: 'collgeg',
        name: 'College',
        // component: () => import('@/views/creation/college.vue'),
        meta: {
          title: '开发者学院',
        },
        hidden: true,
      },
    ],
  },
];
